import values from 'lodash/values'
import { createSelector } from 'reselect'

import { makeFilterRugs, makeSortRugs } from 'Global/Helpers/rugHelpers'
import { userPermissions as _userPermissions } from 'Components/Permissions/selectors'
import { getCurrentAndUpcoming, userHasReservations } from 'Global/Helpers/reservationHelpers'

const _additionalAdvisors = state => state.auth.user.additionalAdvisors
const _page = state => state.layout.myOrders.page
const _rugs = state => state.rugs.data

export const layout = state => state.layout.myOrders.layout
export const limit = state => state.layout.myOrders.limit
export const previewOpen = state => state.previewModal.myOrders.visible
export const rugsDone = state => state.rugs.done
export const rugsError = state => state.rugs.error
export const rugsPending = state => state.rugs.pending
export const sortBy = state => state.layout.myOrders.sortBy
export const sortOrder = state => state.layout.myOrders.sortOrder
export const user = state => state.auth.user

/**
 * Takes the filtered rugs and slices the array to the set limit per page.
 */
export const getAdvisor = createSelector(
  [user],
  user => {
    return `${user.firstName} ${user.lastName}`
  },
)

/**
 * Iterates over all rugs and filters out all rugs
 * which isn't advised by the advisor.
 * @returns {array} Filtered Rugs
 */
export const filterRugs = createSelector(
  [getAdvisor, _additionalAdvisors, sortBy, sortOrder, _rugs, user, _userPermissions],
  (advisor, additionalAdvisors, sortBy, sortOrder, rugs, user, userPermissions) => {
    const filter = makeFilterRugs({}, userPermissions)
    const sort = makeSortRugs(sortBy, sortOrder)

    return values(rugs)
      .filter(filter)
      .filter(rug => {
        if (rug.advisor.toLowerCase().includes(advisor.toLowerCase())) {
          return true
        }

        for (const aA of additionalAdvisors) {
          if (rug.advisor.toLowerCase().includes(aA.trim().toLowerCase())) {
            return true
          }
        }

        let keep = userHasReservations(user, getCurrentAndUpcoming(rug.reservations))

        if (keep === true) {
          return keep
        }

        return false
      })
      .sort(sort)
      .reduce((rugs, rug) => {
        const hasReservations = userHasReservations(user, getCurrentAndUpcoming(rug.reservations))

        if (hasReservations) {
          return [rug, ...rugs]
        }

        return [...rugs, rug]
      }, [])
  },
)

/**
 * Takes the filtered rugs and slices the array to the set limit per page.
 */
export const slicedFilteredRugs = createSelector(
  [filterRugs, limit, _page],
  (filteredRugs, limit, page) => {
    return filteredRugs.slice((page - 1) * limit, (page - 1) * limit + limit)
  },
)

/**
 * Creates a pagination object with current page, total pages, total rugs
 */
export const calculatePagination = createSelector(
  [filterRugs, limit, _page],
  (filteredRugs, limit, page) => {
    return {
      page,
      pages: Math.ceil(filteredRugs.length / limit),
      totalRugs: filteredRugs.length,
    }
  },
)
